import { Mail } from './mail';

export class MailsData {
  count: number;
  pages: number;
  mails: Mail[];

  constructor( data: any = {} ) {
    this.count = data.count;
    this.pages = data.pages;
    this.mails = (data.messages || []).map(( item ) => new Mail(item));
  }
}



// WEBPACK FOOTER //
// ./app/states/mailbox/shared/mails-data.ts